import { AppPageName, appPage } from "./page-info";

export const pathItemsPredicate = (path: string) => path;

export function pageInfo(page: AppPageName[number]) {
  return appPage[page];
}

export function pageBackLinks(page: AppPageName[number]) {
  return appPage[page].backLinks;
}

export function pageName(page: AppPageName[number]) {
  return appPage[page].title;
}

export function pagePath(
  page: AppPageName[number],
  pathParams: Record<string, string | number> = {}
) {
  const { path } = appPage[page];
  const pathItems = path.split(/\//).filter(pathItemsPredicate);

  const reducePredicate = (str: string, pathItem: string) => {
    if (pathItem.startsWith(":")) {
      const param = pathItem.substring(1);
      return pathParams[param] ? `${str}/${pathParams[param]}` : str;
    }
    return `${str}/${pathItem}`;
  };

  return pathItems.reduce(reducePredicate, "");
}

export function routePath(page: AppPageName[number]) {
  return appPage[page].routePath;
}
